/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_New_Group_LabelInputs */



/**
* | output |
* | --- |
* | "*NEW*" |
*
* @param {Marker_Import_New_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_new_group_label = /** @type {((inputs?: Marker_Import_New_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_New_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("*NOUVEAU*")
	if (locale === "de") return /** @type {LocalizedString} */ ("*NEU*")
	if (locale === "it") return /** @type {LocalizedString} */ ("*NUOVO*")
	if (locale === "ru") return /** @type {LocalizedString} */ ("*НОВЫЙ*")
	if (locale === "es") return /** @type {LocalizedString} */ ("*NUEVO*")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("*新的*")
	if (locale === "ja") return /** @type {LocalizedString} */ ("*新しい*")
	if (locale === "hi") return /** @type {LocalizedString} */ ("*नया*")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("*NOVO*")
	return /** @type {LocalizedString} */ ("*NEW*")
});